import React, { useEffect, useState } from 'react';
import {
  DialogRoot,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogCloseTrigger,
} from '@/components/ui/dialog';
import { LocationCreateForm } from './location-create-form';
import { AuthTypeCreateModal } from './location-auth-type-create-modal';
import { AuthType, CreateLocationBody } from '../locations.types';

interface LocationCreateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (location: CreateLocationBody) => void;
}

export const LocationCreateModal: React.FC<LocationCreateModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  // State for auth type creation flow
  const [isAuthTypeCreateModalOpen, setIsAuthTypeCreateModalOpen] =
    useState(false);

  const [authTypes, setAuthTypes] = useState<AuthType[]>([]);

  const handleLocationSuccess = (location: CreateLocationBody) => {
    onSuccess?.(location);
    onClose();
  };

  const handleLocationCancel = () => {
    onClose();
  };

  const handleAddAuthType = () => {
    setIsAuthTypeCreateModalOpen(true);
  };

  const handleAuthTypeCreateSuccess = (authType: AuthType) => {
    setAuthTypes([...authTypes, authType]);
    setIsAuthTypeCreateModalOpen(false);
  };

  const handleAuthTypeCreateClose = () => {
    setIsAuthTypeCreateModalOpen(false);
  };

  const handleResetAuth = () => {
    // Clear all auth types to reset the configuration
    setAuthTypes([]);
  };

  return (
    <>
      <DialogRoot
        open={isOpen}
        onOpenChange={(details: { open: boolean }) =>
          !details.open && onClose()
        }
        closeOnInteractOutside={false}
      >
        <DialogContent maxW="800px" maxH="90vh" overflowY="auto">
          <DialogHeader>
            <DialogTitle>Add New Location</DialogTitle>
          </DialogHeader>
          <DialogCloseTrigger />
          <DialogBody pb={6}>
            <LocationCreateForm
              onSuccess={handleLocationSuccess}
              onCancel={handleLocationCancel}
              onAddAuthType={handleAddAuthType}
              onResetAuth={handleResetAuth}
              authTypes={authTypes}
            />
          </DialogBody>
        </DialogContent>
      </DialogRoot>

      {/* Auth Type Create Modal - Directly create Basic Auth */}
      <AuthTypeCreateModal
        isOpen={isAuthTypeCreateModalOpen}
        onClose={handleAuthTypeCreateClose}
        template="basic"
        onSuccess={handleAuthTypeCreateSuccess}
      />
    </>
  );
};
